export default Object.freeze({
    MANAGEMENT: 'management',
    PRODUCTION: 'production',
    CONSTRUCTION: 'construction',
    ADMINISTRATION: 'administration',
    SLOVAKIA: 'slovakia',
});
